type CandidateDisplayNameSource = {
  id: number | string;
  firstName?: string | null;
  lastName?: string | null;
};

export const getCandidateDisplayName = ({
  id,
  firstName,
  lastName,
}: CandidateDisplayNameSource): string =>
  [firstName?.trim(), lastName?.trim()].filter(Boolean).join(' ') ||
  `Кандидат №${id}`;
